import React, { useState } from "react";

export default function StepUpAuthModal({ title = "Confirmation de Sécurité", actionName = "Cette action sensible", totpEnabled = false, onConfirm, onCancel, onEnrollerTotp }) {
  const [totpCode, setTotpCode] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  // Le compte n'a NI mot de passe NI 2FA : lui demander une preuve serait une
  // impasse. Le backend le signale par le code NO_FACTOR_AVAILABLE, distinct
  // de STEPUP_REQUIRED (« tu n'as pas fourni ») — cf. verify_stepup_auth.
  const [sansFacteur, setSansFacteur] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const payload = {};
      const headers = {};

      if (totpEnabled) {
        if (!totpCode || totpCode.trim().length !== 6) {
          setError("Veuillez saisir un code 2FA valide à 6 chiffres.");
          setLoading(false);
          return;
        }
        headers["X-TOTP-Code"] = totpCode.trim();
        payload.totp_code = totpCode.trim();
      } else {
        payload.password = password;
      }

      const res = await onConfirm(payload, headers);
      setLoading(false);

      if (res && res.code === "NO_FACTOR_AVAILABLE") {
        setSansFacteur(true);
        setError("");
        return;
      }
      if (res && res.error) {
        setError(res.error);
      }
    } catch (err) {
      setLoading(false);
      setError("Erreur lors de la validation de la sécurité.");
    }
  };

  return (
    <div style={{
      position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
      background: "rgba(0, 0, 0, 0.85)", backdropFilter: "blur(8px)",
      zIndex: 9999, display: "flex", justifyContent: "center", alignItems: "center",
      padding: "20px"
    }}>
      <div style={{
        background: "#12131C", border: "1px solid #2A2D3E", borderRadius: "16px",
        maxWidth: "420px", width: "100%", padding: "30px", boxShadow: "0 20px 50px rgba(0,0,0,0.8)",
        color: "#fff", fontFamily: "Inter, system-ui, sans-serif"
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
          <h3 style={{ margin: 0, fontSize: "1.2rem", color: "#ff0055" }}>🛡️ {title}</h3>
          <button onClick={onCancel} style={{ background: "none", border: "none", color: "#888", fontSize: "1.5rem", cursor: "pointer" }}>×</button>
        </div>

        <p style={{ color: "#aaa", fontSize: "0.88rem", marginBottom: "20px", lineHeight: "1.4" }}>
          <strong>{actionName}</strong> nécessite une validation de sécurité renforcée.
        </p>

        {sansFacteur ? (
          <div>
            <div style={{ background: "rgba(255,170,0,0.12)", border: "1px solid #ffaa00", borderRadius: "8px", padding: "14px", color: "#ffcc66", fontSize: "0.87rem", lineHeight: "1.5", marginBottom: "20px" }}>
              Aucun facteur de sécurité n'est configuré sur ce compte.
              <br /><br />
              Votre connexion Google identifie votre compte, mais ne prouve pas
              votre présence maintenant. Activez la double authentification pour
              pouvoir réaliser cette action.
            </div>
            <div style={{ display: "flex", gap: "10px" }}>
              <button
                type="button"
                onClick={onCancel}
                style={{ flex: 1, padding: "12px", background: "transparent", border: "1px solid #444", borderRadius: "8px", color: "#ccc", cursor: "pointer" }}
              >
                Plus tard
              </button>
              <button
                type="button"
                onClick={onEnrollerTotp}
                disabled={!onEnrollerTotp}
                style={{ flex: 1, padding: "12px", background: "linear-gradient(135deg, #00c853, #00897b)", border: "none", borderRadius: "8px", color: "#fff", fontWeight: "bold", cursor: onEnrollerTotp ? "pointer" : "not-allowed", opacity: onEnrollerTotp ? 1 : 0.5 }}
              >
                Activer la 2FA
              </button>
            </div>
          </div>
        ) : (
        <>
        {error && (
          <div style={{ background: "rgba(255,50,50,0.15)", border: "1px solid #ff3232", borderRadius: "8px", padding: "10px", color: "#ff8888", fontSize: "0.85rem", marginBottom: "15px" }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          {totpEnabled ? (
            <div style={{ marginBottom: "20px" }}>
              <label style={{ display: "block", fontSize: "0.85rem", color: "#00f0ff", marginBottom: "8px", fontWeight: "bold" }}>
                Code 2FA (Google Authenticator / Authy)
              </label>
              <input
                type="text"
                maxLength={6}
                required
                autoFocus
                placeholder="123456"
                value={totpCode}
                onChange={(e) => setTotpCode(e.target.value)}
                style={{
                  width: "100%", padding: "12px", background: "#1A1C29", border: "1px solid #00f0ff",
                  borderRadius: "8px", color: "#00f0ff", fontSize: "1.2rem", textAlign: "center",
                  letterSpacing: "4px", fontWeight: "bold", boxSizing: "border-box"
                }}
              />
            </div>
          ) : (
            <div style={{ marginBottom: "20px" }}>
              <label style={{ display: "block", fontSize: "0.85rem", color: "#ccc", marginBottom: "8px" }}>
                Confirmez votre mot de passe
              </label>
              <input
                type="password"
                required
                autoFocus
                placeholder="Votre mot de passe actuel"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{
                  width: "100%", padding: "12px", background: "#1A1C29", border: "1px solid #33374A",
                  borderRadius: "8px", color: "#fff", fontSize: "0.95rem", boxSizing: "border-box"
                }}
              />
            </div>
          )}

          <div style={{ display: "flex", gap: "10px" }}>
            <button
              type="button"
              onClick={onCancel}
              style={{
                flex: 1, padding: "12px", background: "transparent", border: "1px solid #444",
                borderRadius: "8px", color: "#ccc", cursor: "pointer"
              }}
            >
              Annuler
            </button>
            <button
              type="submit"
              disabled={loading}
              style={{
                flex: 1, padding: "12px", background: "linear-gradient(135deg, #ff0055, #7000ff)",
                border: "none", borderRadius: "8px", color: "#fff", fontWeight: "bold", cursor: "pointer",
                opacity: loading ? 0.6 : 1
              }}
            >
              {loading ? "Vérification..." : "Confirmer"}
            </button>
          </div>
        </form>
        </>
        )}
      </div>
    </div>
  );
}
